module.exports = __webpack_public_path__ + "static/thumbnail-1a8809a9420004a4f6e688798969f8ee.png";